"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const java_class_tools_1 = require("java-class-tools");
const ConstantPool_1 = require("./ConstantPool");
const utils_1 = require("./utils");
const Const_1 = require("./Const");
const Operands_1 = require("./Operands");
const reader = new java_class_tools_1.JavaClassFileReader();
class ClassReader {
    constructor(data) {
        this.enumInfos = null;
        this.classFile = reader.read(data);
        this.fullyQualifiedName = this.getFullyQualifiedName();
        this.superClass = this.getSuperClass();
        this.dependClass = this.getDependClass();
        this.interfaceName = this.getInterfaceName();
        this.classInfo = this.getClassInfo();
    }
    getAllInfo({ showCode } = {}) {
        const { superClass, dependClass, interfaceName, fullyQualifiedName, classInfo } = this;
        const { fieldsInfo, enumFieldsInfo } = this.getFieldsInfo();
        const methodsInfo = this.getMethodsInfo({ showCode });
        const { enumInfos } = this;
        return {
            package: fullyQualifiedName.slice(0, fullyQualifiedName.lastIndexOf('.')),
            dependClass,
            fullyQualifiedName,
            superClass,
            interfaceName,
            classInfo,
            methodsInfo,
            fieldsInfo,
            enumFieldsInfo,
            enumInfos,
        };
    }
    getInterfaceName() {
        const { constant_pool, interfaces, } = this.classFile;
        return interfaces.map((itf) => (ConstantPool_1.readData(constant_pool, itf).name));
    }
    getFullyQualifiedName() {
        const { constant_pool, this_class, } = this.classFile;
        return ConstantPool_1.readData(constant_pool, this_class).name;
    }
    getSuperClass() {
        const { constant_pool, super_class, } = this.classFile;
        return ConstantPool_1.readData(constant_pool, super_class).name;
    }
    getDependClass() {
        const { constant_pool } = this.classFile;
        const { superClass, fullyQualifiedName } = this;
        const dependClasses = [];
        constant_pool.forEach((classInfo) => {
            if (utils_1.isEmpty(classInfo))
                return;
            if (classInfo.tag === 7) {
                const { name } = ConstantPool_1.readData(constant_pool, classInfo.name_index);
                if (name !== fullyQualifiedName && !(/^java\.lang\.[a-zA-z]+$/.test(name)) && !(/^java\.util\.[a-zA-z]+$/.test(name))) {
                    if (superClass === 'java.lang.Enum' && name === `${fullyQualifiedName}[]`)
                        return;
                    dependClasses.push(name);
                }
            }
        });
        return dependClasses;
    }
    getClassInfo() {
        const info = {};
        const { constant_pool, attributes, } = this.classFile;
        attributes.forEach((attribute) => {
            const { signature_index, sourcefile_index, attribute_name_index, annotations, } = attribute;
            const attrName = ConstantPool_1.readData(constant_pool, attribute_name_index);
            if (!utils_1.isEmpty(signature_index)) {
                const signature = ConstantPool_1.readData(constant_pool, signature_index);
                info[attrName.name] = signature.name;
            }
            if (!utils_1.isEmpty(sourcefile_index)) {
                const sourcefile = ConstantPool_1.readData(constant_pool, sourcefile_index);
                info[attrName.name] = sourcefile.name;
            }
            if (!utils_1.isEmpty(annotations)) {
                const annos = ConstantPool_1.getAnnotations(constant_pool, annotations);
                utils_1.mixinArr(this.dependClass, Object.keys(annos));
                info.annotations = annos;
            }
        });
        return info;
    }
    getMethodsInfo({ showCode = false, } = {}) {
        const { constant_pool, methods, } = this.classFile;
        const isEnum = this.superClass === 'java.lang.Enum';
        const methodsInfo = [];
        const readMap = new Map();
        methods.forEach((method) => {
            const { access_flags, name_index, descriptor_index, attributes, } = method;
            const methodName = ConstantPool_1.readData(constant_pool, name_index).name;
            const paramTypes = ConstantPool_1.readData(constant_pool, descriptor_index).name;
            if (isEnum && ~['values', 'valueOf'].indexOf(methodName))
                return;
            const methodInfo = {
                methodName,
                paramTypes,
                ACC: Const_1.getACC(access_flags),
            };
            if (methodName === '<clinit>') {
            }
            if (!utils_1.isEmpty(attributes)) {
                for (const attribute of attributes) {
                    const { code, annotations, signature_index, attribute_name_index, exception_index_table, } = attribute;
                    if (!utils_1.isEmpty(annotations)) {
                        const annos = ConstantPool_1.getAnnotations(constant_pool, annotations);
                        utils_1.mixinArr(this.dependClass, Object.keys(annos));
                        methodInfo.annotations = annos;
                    }
                    if (attribute_name_index) {
                        const attrName = ConstantPool_1.readData(constant_pool, attribute_name_index).name;
                        if (attrName === 'Code' && code) {
                            const instructions = java_class_tools_1.InstructionParser.fromBytecode(code);
                            if (showCode)
                                methodInfo.codes = instructions;
                            if (methodName === '<clinit>' && isEnum) {
                                let readIndex = 0;
                                let reading = false;
                                let tempVal = {};
                                const enumVal = [];
                                for (const instruction of instructions) {
                                    const { opcode, operands } = instruction;
                                    const opName = Const_1.InstructionMap.get(opcode).toLowerCase();
                                    if (opcode === java_class_tools_1.Opcode.NEW) {
                                        readIndex = 0;
                                        reading = true;
                                        tempVal = {};
                                    }
                                    else if (reading && opcode === java_class_tools_1.Opcode.DUP) {
                                    }
                                    else if (reading && opName.startsWith('iconst')) {
                                        const name = readMap.get(readIndex++);
                                        const result = opName.replace('iconst_', '').replace('m', '-');
                                        tempVal[name] = +result;
                                    }
                                    else if (reading && opcode === java_class_tools_1.Opcode.LDC) {
                                        const name = readMap.get(readIndex++);
                                        const result = ConstantPool_1.readData(constant_pool, operands[0]).name;
                                        tempVal[name] = result;
                                    }
                                    else if (reading && opcode === java_class_tools_1.Opcode.SIPUSH) {
                                        const name = readMap.get(readIndex++);
                                        const result = Operands_1.default.SIPUSH(instruction.operands);
                                        tempVal[name] = result;
                                    }
                                    else if (reading && opcode === java_class_tools_1.Opcode.BIPUSH) {
                                        const name = readMap.get(readIndex++);
                                        const result = Operands_1.default.BIPUSH(instruction.operands);
                                        tempVal[name] = result;
                                    }
                                    else if (reading && opcode === java_class_tools_1.Opcode.INVOKESPECIAL) {
                                        enumVal.push(tempVal);
                                        reading = false;
                                    }
                                }
                                methodInfo.enum = enumVal.map(({ EnumOrder, ...val }) => Object.values(val));
                                this.enumInfos = enumVal;
                            }
                        }
                        if (attrName === 'Exceptions' && exception_index_table) {
                            methodInfo.exception = exception_index_table.map((expt) => ConstantPool_1.readData(constant_pool, expt).name);
                        }
                        if (attrName === 'Signature' && signature_index) {
                            const paramDetailTypes = ConstantPool_1.readData(constant_pool, signature_index);
                            methodInfo.paramDetailTypes = paramDetailTypes.name;
                        }
                    }
                    if (!utils_1.isEmpty(attribute.attributes)) {
                        for (const attr of attribute.attributes) {
                            const { attribute_name_index, local_variable_table, line_number_table, entries, } = attr;
                            const attrName = ConstantPool_1.readData(constant_pool, attribute_name_index).name;
                            if (attrName === 'StackMapTable' && entries) {
                                methodInfo.entries = entries.map((entry) => {
                                    return entry;
                                });
                            }
                            if (attrName === 'LineNumberTable' && line_number_table) {
                                methodInfo.LineNumberTable = line_number_table;
                            }
                            if (attrName === 'LocalVariableTable' && local_variable_table) {
                                const variable = {};
                                const parameters = {};
                                local_variable_table.sort((l1, l2) => (l1.index - l2.index));
                                const paramLen = (methodInfo.paramTypes[0] || []).length;
                                for (const attrVar of local_variable_table) {
                                    const { index, name_index, descriptor_index, } = attrVar;
                                    const variName = ConstantPool_1.readData(constant_pool, name_index).name;
                                    const typeName = ConstantPool_1.readData(constant_pool, descriptor_index).name;
                                    variable[variName] = typeName;
                                    if (Object.keys(parameters).length < paramLen) {
                                        if (methodInfo.ACC.indexOf('static') > -1) {
                                            parameters[variName] = typeName;
                                        }
                                        else if (index > 0) {
                                            parameters[variName] = typeName;
                                        }
                                    }
                                }
                                if (isEnum && methodName === '<init>') {
                                    const [inParam, outParam] = paramTypes;
                                    const [, , ...newInParam] = inParam;
                                    methodInfo.paramTypes = [newInParam, outParam];
                                    let readIndex = 0;
                                    readMap.set(readIndex, 'EnumName');
                                    readMap.set(++readIndex, 'EnumOrder');
                                    for (const { index, name_index } of local_variable_table) {
                                        if (index > 0 && readIndex - 2 <= paramLen) {
                                            readMap.set(++readIndex, ConstantPool_1.readData(constant_pool, name_index).name);
                                        }
                                    }
                                }
                                methodInfo.LocalVariableTable = {
                                    variable,
                                    parameters,
                                };
                            }
                        }
                    }
                }
            }
            methodsInfo.push(methodInfo);
        });
        return methodsInfo;
    }
    getFieldsInfo() {
        const { constant_pool, fields, } = this.classFile;
        const fieldsInfo = [];
        const enumFieldsInfo = [];
        for (const field of fields) {
            const { access_flags, descriptor_index, name_index, attributes, } = field;
            const fieldName = ConstantPool_1.readData(constant_pool, name_index).name;
            const type = ConstantPool_1.readData(constant_pool, descriptor_index).name;
            if (this.superClass === 'java.lang.Enum' && fieldName === '$VALUES')
                continue;
            const fieldInfo = {
                fieldName,
                type,
            };
            fieldInfo.ACC = Const_1.getACC(access_flags);
            for (const attr of attributes) {
                const { attribute_name_index, constantvalue_index, annotations, signature_index, } = attr;
                const attrName = ConstantPool_1.readData(constant_pool, attribute_name_index);
                const attrValue = ConstantPool_1.readData(constant_pool, constantvalue_index);
                if (attrValue.name) {
                    fieldInfo[attrName.name] = attrValue.name;
                }
                if (!utils_1.isEmpty(signature_index)) {
                    const signature = ConstantPool_1.readData(constant_pool, signature_index);
                    fieldInfo.type = signature.name;
                }
                if (!utils_1.isEmpty(annotations)) {
                    const annos = ConstantPool_1.getAnnotations(constant_pool, annotations);
                    utils_1.mixinArr(this.dependClass, Object.keys(annos));
                    fieldInfo.annotations = annos;
                }
            }
            if (fieldInfo.type === this.getFullyQualifiedName()) {
                enumFieldsInfo.push(fieldInfo);
            }
            else {
                fieldsInfo.push(fieldInfo);
            }
        }
        return {
            fieldsInfo,
            enumFieldsInfo,
        };
    }
}
exports.default = ClassReader;
